export default class EditorBaseComponentVO {
    constructor(property, propertyLabel, units, min, max, defaults, type, extendedControls = false, component = null, isResponsive = false, extendedControlIcons = null) {
        this._property = property;
        this._propertyLabel = propertyLabel;
        this._units = units;
        this._min = min;
        this._max = max;
        this._defaults = defaults;
        this._type = type;
        this._extendedControls = extendedControls;
        this._component = component;
        this._isResponsive = isResponsive;
        this._extendedControlIcons = extendedControlIcons;

        if (component) {
            this.setDefault(component);
        }
    }

    get type() {
        return this._type;
    }

    get propertyLabel() {
        return this._propertyLabel;
    }

    get extendedControlIcons() {
        return this._extendedControlIcons;
    }

    get property() {
        return this._property;
    }

    get units() {
        return this._units;
    }

    get min() {
        return this._min;
    }

    get max() {
        return this._max;
    }

    get defaults() {
        return this._defaults;
    }

    get extendedControls() {
        return this._extendedControls;
    }

    get isResponsive() {
        return this._isResponsive;
    }

    get component() {
        return this._component;
    }

    setDefault(component) {
        let styles = component.getStyle(),
            value = styles[this._property],
            parsedValue = parseInt(value, 10),
            isValidValue = typeof value !== 'undefined' && !isNaN(parsedValue);
        this._component = component;

        if (isValidValue) {
            this._defaults = styles[this._property];
        }
    }

    toObject() {
        return {
            type: this.type,
            propertyLabel: this.propertyLabel,
            min: this.min,
            max: this.max,
            property: this.property,
            units: this.units,
            defaults: this.defaults,
            extendedControls: this.extendedControls,
            component: this.component,
            isResponsive: this.isResponsive,
            extendedControlIcons: this.extendedControlIcons
        };
    }
}